/**
 * 微应用【模块ID - 路由】对照表
 * 暂时由前端来维护，后期可能会有变化
 * 需要根据/mediax-system/main/mods接口返回的数据更新维护
 * 开头必须带斜线！！！
 * todo 缺少期刊缺少期刊缺少期刊缺少期刊注册！！！
 * @type {{mod: string, route: string}[]}
 */
export const routeIdTable = [
  // 用户管理   机构用户管理
  {
    mod: 'admin-user',
    route: '/mediacloud-system/MediaCloudSystem-Org'
  },
  // 参数管理   系统参数
  {
    mod: 'admin-param',
    route: '/mediacloud-system/MediaCloudSystem-Param'
  },
  // 站点管理
  {
    mod: 'admin-site',
    route: '/mediacloud-system/MediaCloudSystem-Site'
  },
  // 属性设置
  {
    mod: 'admin-prop',
    route: '/mediacloud-config/MediaCloudConfig-Prop'
  },
  // 数据浏览设置
  {
    mod: 'set-data-view',
    route: '/mediacloud-config/MediaCloudConfig-Personnel'
  },
  // 存储管理
  {
    mod: 'admin-storage',
    route: '/mediacloud-system/MediaCloudSystem-storages'
  },
  // 三方管理
  {
    mod: 'admin-client',
    route: '/mediacloud-system/MediaCloudSystem-Tripartite'
  },
  // 三方管理
  {
    mod: 'rr-admin-client',
    route: '/mediacloud-system/MediaCloudSystem-Tripartite'
  },
  // 平台配置管理
  {
    mod: 'admin-config',
    route: '/mediacloud-system/MediaCloudSystem-Setting'
  },
  // 系统日志
  {
    mod: 'admin-log',
    route: '/mediacloud-system/MediaCloudSystem-log'
  },
  // APP发布
  {
    mod: 'article-app',
    route: '/mediacloud-publish-center/MediaCloudPublishCenter-App'
  },
  // web发布
  {
    mod: 'article-web',
    route: '/mediacloud-publish-center/MediaCloudPublishCenter-Web'
  },
  // 撤稿中心
  {
    mod: 'article-revoke',
    route: '/mediacloud-publish-center/articleRevoke'
  },
  // 报纸发布
  {
    mod: 'article-paper',
    route: '/mediacloud-paper/paper-article'
  },
  // 微信发布
  {
    mod: 'article-weixin',
    route: '/mediacloud-article-wx/article-wx'
  },
  // 数字报发布
  {
    mod: 'digital-paper',
    route: '/rc-paper/numpaper-numpaper'
  },
  // 微博
  {
    mod: 'article-weibo',
    route: '/mediacloud-article-wx/article-wb'
  },
  // 电视广播 article-tv
  {
    mod: 'article-tv',
    route: '/mediacloud-article-wx/article-tv'
  },
  // APP栏目
  {
    mod: 'set-column',
    route: '/mediacloud-release-end/appColumnConfig'
  },
  // 网站栏目
  {
    mod: 'set-column-web',
    route: '/mediacloud-release-end/webColumnConfig'
  },
  // 智能机器人
  {
    mod: 'intelli-robot',
    route: '/mediacloud-release-end/intelligent-robot'
  },
  //小记者
  {
    mod: 'uc-reporter',
    route: '/mediacloud-release-end/young-reporter'
  },
  // 网站设置
  {
    mod: 'set-web',
    route: '/mediacloud-release-end/webConfig'
  },
  // 微信设置
  {
    mod: 'set-weixin',
    route: '/mediacloud-article-wx/WxSet'
  },
  // 微博设置
  {
    mod: 'set-weibo',
    route: '/mediacloud-article-wx/othersConfig'
  },
  // 电视广播设置
  {
    mod: 'set-article-tv',
    route: '/mediacloud-article-wx/TvConfig'
  },
  // 媒体号-视频号设置
  {
    mod: 'set-article-video',
    route: '/mediacloud-article-video/config'
  },
  // 媒体号设置
  {
    mod: 'set-article-mo',
    route: '/mediacloud-article-video/othersConfig'
  },
  // 媒体号-稿件
  {
    mod: 'article-video',
    route: '/mediacloud-article-video/article-video'
  },
  // 第三方媒体号-稿件
  {
    mod: 'article-mo',
    route: '/mediacloud-article-video/article-others'
  },
  // 稿件类型设置
  {
    mod: 'set-article-cat',
    route: '/mediacloud-config/MediaCloudConfig-ArticleTypeCat'
  },
  // 空间管理
  {
    mod: 'set-space',
    route: '/mediacloud-release-end/spaceManage'
  },
  // 订阅管理设置
  {
    mod: 'set-column-rss',
    route: '/mediacloud-release-end/subscribe'
  },
  // 广告管理
  {
    mod: 'set-ad-start',
    route: '/mediacloud-release-end/MediaCloudReleaseEnd-ADStart'
  },
  // 推荐管理
  {
    mod: 'set-column-module',
    route: '/mediacloud-release-end/MediaCloudReleaseEnd-Recommendation'
  },

  // 报纸管理
  {
    mod: 'set-paper',
    route: '/mediacloud-paper-manage/MediaCloudPaperManage-Paper'
  },
  // 报纸栏目
  {
    mod: 'set-paper-column',
    route: '/mediacloud-paper-manage/MediaCloudPaperManage-Column'
  },
  // 版次管理
  {
    mod: 'set-paper-layout',
    route: '/mediacloud-paper-manage/MediaCloudPaperManage-Layout'
  },
  // 存储参数管理
  {
    mod: 'set-paper-storage',
    route: '/mediacloud-paper-manage/MediaCloudPaperManage-StorageParams'
  },
  {
    mod: 'set-paper-param',
    route: '/mediacloud-paper-manage/MediaCloudPaperManage-PaperParams'
  },
  // 版面规划
  {
    mod: 'set-layout-plan',
    route: '/mediacloud-paper-manage/MediaCloudPaperManage-LayoutPlan'
  },
  // 刊物管理
  {
    mod: 'set-journal',
    route: '/mediacloud-journal/journalManage'
  },
  // 刊期管理
  {
    mod: 'set-journal-period',
    route: '/mediacloud-journal/periodConfig'
  },
  // 栏目管理
  {
    mod: 'set-journal-column',
    route: '/mediacloud-journal/columnManage'
  },
  // 期刊栏目稿件
  {
    mod: 'article-journal',
    route: '/mediacloud-journal/home'
  },
  {
    mod: 'admin-menu',
    route: '/main-manage'
  },
  {
    mod: 'photo',
    route: '/resource-center-photos/ImgLibraryList'
  },
  // 发布端
  {
    mod: 'set-release',
    route: '/mediacloud-release-end/index'
  },
  // 标引项
  {
    mod: 'set-photo-label',
    route: '/resource-center-photos/SystemIndexing'
  },
  // 元数据
  {
    mod: 'set-photo-cat',
    route: '/resource-center-photos/SystemMetadata'
  },
  // 水印设置
  {
    mod: 'set-photo-watermark',
    route: '/resource-center-photos/SystemWatermark'
  },
  // 图片管理
  {
    mod: 'set-photo',
    route: '/resource-center-photos/SystemTab'
  },
  // 新华社稿件
  {
    mod: 'article-wire',
    route: '/mediacloud-wire/article-wire'
  },
  {
    mod: 'photo-wire',
    route: '/mediacloud-wire/photo-wire'
  },
  // 会员管理
  {
    mod: 'uc-member',
    route: '/module-member-web/userManage'
  },
  // 会员等级
  {
    mod: 'uc-level',
    route: '/module-member-web/MemberLevel'
  },
  // 邀请码管理
  {
    mod: 'uc-invitecode',
    route: '/module-member-web/invitationCodeManage'
  },
  // 积分规则
  {
    mod: 'uc-score-rule',
    route: '/module-member-web/integralRuleYwzt'
  },
  // 消息模板-基础对接配置
  {
    mod: 'set-uc-msg-base',
    route: '/module-member-web/basics'
  },
  // 消息模板-模板配置
  {
    mod: 'set-uc-msg-template',
    route: '/module-member-web/template'
  },
  // 编稿库（管理中心）
  {
    mod: 'set-article-edit',
    route: '/mediacloud-article-edit/config'
  },
  // 编稿库（首页）
  {
    mod: 'article-edit',
    route: '/mediacloud-article-edit/home'
  },
  // 稿源库（管理中心）
  {
    mod: 'set-article-origin',
    route: '/mediacloud-article-origin/config'
  },
  // 稿源库（首页）
  {
    mod: 'article-root',
    route: '/mediacloud-article-origin/home'
  },
  // 个人稿库（首页）
  {
    mod: 'article-my',
    route: '/mediacloud-article-my/home'
  },

  {
    mod: 'admin-notice',
    route: '/mediacloud-article-my/publicManagement'
  },
  {
    mod: 'set-notice', // 音视频-转码模板
    route: '/mediacloud-article-my/config'
  },
  {
    mod: 'zhihui_testIndex', // 学科管理
    route: '/module-prodb/prodb/ui/testIndex'
  },
  {
    mod: 'zhihui_testAttribute', // 试卷标引属性
    route: '/module-prodb/prodb/ui/testAttribute'
  },
  {
    mod: 'zhihui_questionBank', // 试题库
    route: '/module-prodb/prodb/ui/questionBank'
  },
  {
    mod: 'zhihui_testBank', // 试卷库
    route: '/module-prodb/prodb/ui/testBank'
  },
  {
    mod: 'zhihui_questionFiles', // 文档库
    route: '/module-prodb/prodb/ui/questionFiles'
  },
  {
    mod: 'zhihui_specialExam', // 专项考试
    route: '/module-prodb/prodb/ui/specialExam?examType=1'
  },
  {
    mod: 'zhihui_examScore', // 成绩管理
    route: '/module-prodb/prodb/ui/examScore'
  },
  {
    mod: 'zhihui_certificateManage', // 证书管理
    route: '/module-prodb/prodb/ui/certificateManage'
  },
  {
    mod: 'set-video-group', // 音视频-分组设置
    route: '/mediacloud-mam/MediaCloudMam-GroupSetting'
  },
  {
    mod: 'set-video-transtemp', // 音视频-转码模板
    route: '/mediacloud-mam/MediaCloudMam-Trantemp'
  },
  {
    mod: 'video', // 音视频成品库-视频
    route: '/mediacloud-mam/MediaCloudMam-Video'
  },
  {
    mod: 'audio', // 音视频成品库-音频
    route: '/mediacloud-mam/MediaCloudMam-Audio'
  },
  {
    mod: 'article-audit', // 终审稿库-列表
    route: '/mediacloud-article-audit/home'
  },
  {
    mod: 'set-article-audit', // 终审稿库-配置
    route: '/mediacloud-article-audit/config'
  },
  {
    mod: 'set-mbd-track', // 大数据-互联网数据设置
    route: '/mbd-track/settings'
  },
  {
    mod: 'mbd-rank-list', // 大数据-网络热榜
    route: '/mbd-track/ranklist'
  },
  {
    mod: 'mbd-local-news', // 大数据-本地要闻
    route: '/mbd-track/localnews'
  },
  {
    mod: 'mbd-local-topic', // 大数据-本地热点
    route: '/mbd-track/localtopic'
  },
  {
    mod: 'mbd-category-topic', // 大数据-分类热点
    route: '/mbd-track/categorytopic'
  },
  {
    mod: 'my-subscribe', // 个人工作台-我的订阅
    route: '/mbd-track/mysubscribe'
  },
  {
    mod: 'set-mbd-base', //大数据基础设置
    route: '/mbd-settings'
  },
  {
    mod: 'set-mbd-tags', //大数据数据标签管理
    route: '/mbd-etl/tags'
  },
  {
    mod: 'set-mbd-source', //数据来源配置
    route: '/mbd-etl/source/ds'
  },
  {
    mod: 'set-mbd-target', //数据去向配置
    route: '/mbd-etl/business/ds'
  },
  {
    mod: 'set-mbd-task', //接入任务管理
    route: '/mbd-etl/tasks'
  },
  {
    mod: 'set-mbd-storage', //业务库管理
    route: '/mbd-etl/business/lib'
  },
  {
    mod: 'mate-paper-layout', // 见报成品-见报版面
    route: '/rc-paper/paper-page'
  },
  {
    mod: 'mate-paper-photo', // 见报成品-见报图片
    route: '/rc-paper/paper-image'
  },
  {
    mod: 'mate-paper-article', // 见报成品-见报稿件
    route: '/rc-paper/paper-article'
  },
  // {
  //   mod: 'mate-paper-article', // 见报成品-见报稿件
  //   route: '/rc-paper/paper-article'
  // },
  {
    mod: 'set-mbd-special', // 专题--专题分组设置
    route: '/rc-special-topic/groups'
  },
  {
    mod: 'mbd-special', // 专题--专题主页
    route: '/rc-special-topic/topics'
  },
  {
    mod: 'mbd-behavior', // 渠道运营
    route: '/mbd-behavior/analysis'
  },
  {
    mod: 'mbd-stat-usage', // 数据使用分析
    route: '/mbd-behavior/usageanalysis'
  },
  {
    mod: 'set-mbd-api-auth', //大数据数据接口授权
    route: '/mbd-etl/auth'
  },
  {
    mod: 'set-mate-paper', // 见报成品设置
    route: '/rc-paper/paper-papers'
  },
  {
    mod: 'nis-discuss', // 评论管理
    route: '/mediacloud-release-end/discuss'
  },
  {
    mod: 'set-feedback', // 意见管理
    route: '/mediacloud-release-end/feedback'
  },
  {
    mod: 'nis-tv', // 电视广播
    route: '/mediacloud-release-end/tv'
  },
  {
    mod: 'nis-qa', // 问政
    route: '/mediacloud-release-end/qa'
  },
  {
    mod: 'nis-tipoff', // 爆料
    route: '/mediacloud-nis/tip-off'
  },
  // 社圈管理
  {
    mod: 'nis-circle',
    route: '/mediacloud-nis/social-circle'
  },

  // 问卷星
  {
    mod: 'nis-poll',
    route: '/mediacloud-nis/poll'
  },

  // 社圈管理
  {
    mod: 'nis-activity',
    route: '/mediacloud-nis/activity'
  },
  // 抽奖活动
  {
    mod: 'nis-lottery',
    route: '/mediacloud-nis/nis-lottery'
  },

  {
    mod: 'nis-live', // 直播
    route: '/mediacloud-release-end/live'
  },
  {
    mod: 'nis-commodity', // 商品管理
    route: '/mediacloud-release-end/commodityManage'
  },
  {
    mod: 'mbd-mate-article', // 大数据-新媒体成品库
    route: '/mbd-article-finished/articles'
  },
  {
    mod: 'stat-my', // 数据分析-我的工作量
    route: '/mediacloud-datanalysis/my-workload'
  },
  {
    mod: 'stat-org', // 数据分析-部门工作量
    route: '/mediacloud-datanalysis/dept-workload'
  },
  {
    mod: 'admin-stat', // 数据分析-部门工作量
    route: '/mediacloud-datanalysis/statistics'
  },
  {
    mod: 'plan-topic', // 选题策划
    route: '/mediacloud-newsplan/plan-topic'
  },
  // 选题策划-稿库设置
  {
    mod: 'set-plan-topic',
    route: '/mediacloud-newsplan/config'
  },
  // APP分类设置
  {
    mod: 'set-app-cat',
    route: '/mediacloud-release-end/webSortSetting'
  },
  // 我的素材
  {
    mod: 'my-material',
    route: '/mediacloud-production-source/myMaterials'
  },
  // 我的待办
  {
    mod: 'my-todo',
    route: '/mediacloud-article-my/myTodo'
  },
  // 我的消息
  {
    mod: 'my-message',
    route: '/mediacloud-article-my/myMessage'
  },
  // 我的经办
  {
    mod: 'my-handle',
    route: '/mediacloud-article-my/myHandle'
  },
  // 我的指令
  {
    mod: 'rr-command-receiver',
    route: '/mediacloud-article-my/rr-command-receiver'
  },
  // 云端稿库-区划管理
  {
    mod: 'rr-admin-district',
    route: '/mediacloud-distinct/mediacloud-rr-region'
  },
  // 云端稿库-选用记录
  {
    mod: 'rr-select-record',
    route: '/mediacloud-distinct/mediacloud-rr-selectionRecord'
  },
  // 云端稿库-参数管理
  {
    mod: 'rr-admin-param',
    route: '/mediacloud-distinct/mediacloud-rr-param'
  },
  // 云端稿库-指令下达
  {
    mod: 'rr-command',
    route: '/mediacloud-distinct/mediacloud-rr-instruct'
  },
  // 云端稿库-融媒汇聚
  {
    mod: 'rr-converged',
    route: '/mediacloud-distinct/mediacloud-rr-converge'
  },
  // 云端稿库-必推稿库
  {
    mod: 'rr-recommend',
    route: '/mediacloud-distinct/mediacloud-rr-bitui'
  },
  // 云端稿库-必推稿库分类
  {
    mod: 'rr-admin-cat',
    route: '/mediacloud-distinct/mediacloud-rr-bituiGroup'
  },
  // 云端稿库-权威推荐
  {
    mod: 'rr-authority',
    route: '/mediacloud-distinct/mediacloud-rr-authority'
  },
  // 云端稿库-联合策划
  {
    mod: 'rr-topic',
    route: '/mediacloud-distinct/mediacloud-rr-jointPlanning'
  },
  // 云端稿库-平台设置
  {
    mod: 'rr-admin-config',
    route: '/mediacloud-distinct/mediacloud-rr-setting'
  },
  // 系统设置-新华社数据设置
  {
    mod: 'set-article-wire',
    route: '/mediacloud-wire/wire-manage'
  },
  // 系统设置-授权概览
  {
    mod: 'admin-auth',
    route: '/mediacloud-system/MediaCloudSystem-auth'
  },
  //统一检索-全文检索重建索引
  {
    mod: 'admin-index',
    route: '/mediacloud-fts/FtsRebuildIndex'
  },
  // 大数据-精选推荐
  {
    mod: 'mbd-recommend',
    route: '/mbd-track/subscribe'
  },
  // 系统消息
  {
    mod: 'uc-message',
    route: '/mediacloud-article-my/systemMessages'
  },
  // 政情管理
  {
    mod: 'nis-leader',
    route: '/mediacloud-release-end/MediaCloudReleaseEnd-PoliticalSituation'
  },
  // PUGC管理
  {
    mod: 'set-batman',
    route: '/mediacloud-system/batman-management'
  },
  // 人物库
  {
    mod: 'personage',
    route: '/resource-center-photos/personage'
  },
  // 地标库
  {
    mod: 'landmark',
    route: '/resource-center-photos/landmark'
  },
  // 云端稿库-日志审计
  {
    mod: 'rr-admin-log',
    route: '/mediacloud-distinct/mediacloud-rr-log'
  },
  // 数据分析-栏目分析
  {
    mod: 'stat-column',
    route: '/mediacloud-datanalysis/columns-analysis'
  },
  // 数据管理-媒资翻库
  {
    mod: 'admin-tag-traversal',
    route: '/resource-center-photos/MAMTagTraversal'
  },
  // 生产库
  {
    mod: 'mate-produce',
    route: '/mediacloud-production-source/index'
  },
  // 资产库
  {
    mod: 'mate-asset',
    route: '/mediacloud-production-source/propertyIndex'
  },
  // 生产素材设置
  {
    mod: 'set-produce',
    route: '/mediacloud-production-source/setting'
  },
  // 资产库设置
  {
    mod: 'set-asset',
    route: '/mediacloud-production-source/propertySetting'
  },
  // 资产库设置
  {
    mod: 'set-mate-article',
    route: '/mediacloud-production-source/source-article-setting'
  },
  {
    mod: 'set-media-transtemp', // 媒资转码模板
    route: '/mediacloud-production-source/SourceSeeting-Trantemp'
  },
  // 资产稿库
  {
    mod: 'mate-article',
    route: '/mediacloud-production-source/mate-article'
  },
  // 小程序平台
  {
    mod: 'nis-applet',
    route: '/mediacloud-release-end/nis-applet'
  },
  // 举报中心
  {
    mod: 'set-expose',
    route: '/mediacloud-release-end/reportCenter'
  },
  // 专家智库
  {
    mod: 'mate-expert',
    route: '/mediacloud-expert-tank'
  },
  // 供稿单位
  {
    mod: 'set-contributing-unit',
    route: '/mediacloud-config/MediaCloudConfig-ArticleSource'
  },
  //评选管理
  {
    mod: 'nis-selection',
    route: '/mediacloud-expert-tank/selectManagement'
  },
  //小程序设置
  {
    mod: 'set-applet',
    route: '/mediacloud-release-end/minProgram'
  }
]
